import React,{useState} from "react";
import { Link,useLocation } from "react-router-dom";
import toast,{Toaster} from "react-hot-toast";
import { authApi } from "../api/services";

const ForgotPassword = () => {
    const location = useLocation();
    const [email,     setEmail]     = useState(location.state?.email || "");
    const [isLoading, setIsLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!email.trim()) return; 
        setIsLoading(true);
        try{
            await authApi.forgotPassword({ email: email.trim().toLowerCase()});
            setSubmitted(true);
        }
        catch
        {
            toast.error("Failed to send email. Please try again.");
        }
        finally
        {
            setIsLoading(false);
        }
    };
    return (
    <>
      <Toaster position="top-right" />

      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 font-sans">
        <div className="w-full max-w-md">

          {/* Card */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">

            {/* Blue header strip */}
            <div className="bg-gradient-to-r from-blue-900 to-blue-700 px-8 py-6">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center
                              justify-center mb-3">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor"
                     viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                        d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-white">Forgot Password?</h1>
              <p className="text-blue-200 text-sm mt-1">
                We'll send a reset link to your email.
              </p>
            </div>

            <div className="px-8 py-8">
              {!submitted ? (
                /* ── Email form ─────────────────────────────────────────── */
                <>
                  <p className="text-sm text-gray-500 mb-6">
                    Enter the email address associated with your QEDGE account.
                    If it's registered, you'll receive a password-reset link
                    within a few minutes.
                  </p>

                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                      <label className="block text-xs font-semibold text-gray-500
                                        uppercase tracking-wider mb-1.5">
                        Email Address
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@company.com"
                        required
                        autoFocus
                        className="w-full px-4 py-3 bg-gray-50 border border-gray-200
                                   rounded-lg focus:outline-none focus:border-blue-900
                                   focus:ring-1 focus:ring-blue-900 transition-colors
                                   text-sm"
                      />
                    </div>

                    <button
                      type="submit"
                      disabled={isLoading || !email.trim()}
                      className="w-full py-3 bg-blue-900 text-white font-bold rounded-lg
                                 shadow-md hover:bg-blue-800 active:scale-95 transition-all
                                 disabled:opacity-60 disabled:cursor-not-allowed text-sm"
                    >
                      {isLoading ? (
                        <span className="flex items-center justify-center gap-2">
                          <svg className="animate-spin w-4 h-4" fill="none"
                               viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10"
                                    stroke="currentColor" strokeWidth="4"/>
                            <path className="opacity-75" fill="currentColor"
                                  d="M4 12a8 8 0 018-8v8H4z"/>
                          </svg>
                          Sending…
                        </span>
                      ) : (
                        "Send Reset Link"
                      )}
                    </button>
                  </form>
                </>
              ) : (
                /* ── Success confirmation ───────────────────────────────── */
                <div className="text-center py-4">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center
                                  justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-green-600" fill="none"
                         stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                    </svg>
                  </div>
                  <h2 className="text-lg font-bold text-gray-800 mb-2">Check your inbox</h2>
                  <p className="text-sm text-gray-500 mb-1">
                    If <span className="font-semibold text-gray-700">{email}</span> is
                    registered, you'll receive a password-reset link shortly.
                  </p>
                  <p className="text-xs text-gray-400 mb-6">
                    The link expires in 1 hour. Check your spam folder if you don't
                    see it within a few minutes.
                  </p>

                  {/* Resend */}
                  <button
                    type="button"
                    onClick={() => setSubmitted(false)}
                    className="text-sm text-blue-900 font-semibold hover:underline
                               transition-colors"
                  >
                    Try a different email
                  </button>
                </div>
              )}

              {/* Back to login */}
              <div className="mt-6 pt-5 border-t border-gray-100 text-center">
                <Link
                  to="/"
                  className="text-sm text-gray-400 hover:text-blue-900
                             transition-colors flex items-center justify-center gap-1"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor"
                       viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                          d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
                  </svg>
                  Back to Login
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};



export default ForgotPassword;